import { useBillingModels } from '@debbie/cortex/dist/billing-models/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { SystemOrTenantSelect } from './SystemOrTenant.js';
const billingModelId = (billingModel) => billingModel.billingModelId;
const BillingModelSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(SystemOrTenantSelect, { ...props, items: useBillingModels(), getId: billingModelId, labels: {
            placeholder: lang.billingModels.selectBillingModel,
            search: lang.billingModels.searchBillingModels,
            all: lang.economy.billingModels,
            system: lang.billingModels.systemConnector,
            tenant: lang.billingModels.tenantConnector,
        }, recentsStorageKey: "debbie.billingModelSelect.recentlyUsed" }));
};
export default BillingModelSelect;
//# sourceMappingURL=BillingModelSelect.js.map